import { features as BASE } from 'environments/features';


export const FEATURES_AGROGEST = {
    ...BASE,
    applicationType: 'agrogest',

    clientesName: 'Titulares',
    clienteName: 'Titular',
    aplicadorName: 'Aplicador',
    aplicadoresName: 'Aplicadores',

    horticola: true,
    showCultivosBajoAguaFields: true,
    showMultiselectAplicadores: true,
    showEstadisticas: false,
    showAnalisis: true,
    showCargaPAC: true,
    showPartida: true,
    puedeImprimir: true,
    showAbonado: true,
    showTratamientosAllProductos: true,
    showTratamientosExportCsv: true,
    showPhCaldo: false,
    showEnviarWhatsapp: false,
    showEnviarCorreo: true,

    showOrdenAplicacionProductos: true,
    showMeteoBtn: true,
    adminCanSeeAllRecords: true,
    showAnalisisSectorParcelas: true,
    showClientesRegepa: true,
    showNPK: false,
    showParcelasEstacion: true,
    showTareasFitoMotivoJustificacion: false,
    showFertilizantesFormShort: true,
    showFertilizantesS: true,
    showParcelasProvinciaCol: true,
    showParcelasMunicipioCol: true,
    userCanSeeClientes: true,
    userCanSeeCostes: false,
    showTareasFitoLote: true,
    showFertilizantesAlbaranFactura: true,
    showAllCultivosPrecedentes: true,
    showFincasGenGml: false,
    showWidthFertilizanteNombre: true,
    showDesplazamientoObra: false,
    showVentasComercioProveedor: true,
    showTareasFertiGramos: true,
    showTareasFertilizantesTipoFertilizacion: true,
    persisteIdComercio: true,
    showAnalisisNumeroAnalisis: true,
    showTareasMaquinaria: true,
    showAgrupacionEntidadEnParcela: true,
    showParcelasFincasCol: true,
    showParcelasActivoCol: false,
    filterAplicadoresByClient: false,
    showMaquinariaClienteAsignado: false,
    showMaquinariaAdjuntoPdf: true,
    showVentas: true,
    showFertirrigacion: false,
    showPlanAbonado: false,


    showUsuariosFirma: true,
    showBackup: true,

    showMapaLabels: true,
    showMapaTratamientos: true,
    showVentusky: true,

    showControlRiego: false,
    showTareasAgroambiental: false,
    showRecetaPascualCabedo: true,
    showEcorregimenes: false,

    canRecoverPassword: true,
    canRegister: true,

    showTareasFertiObservaciones: true,
    enableLegalMode: true,
    showTareasFitoHoras: false,
    tareasHorasTotales: false,
    showConsultaRopo: true,
    clientesMostrarTodosDefault: true,
    activateSIEX: true,
    horaFechaInicioActualPorDefecto: true,

    showTecnicoAsignado: false,
    showAplicados: false,
    showFitoFechaReceta: true,
    userCanSeeAllRecords: true,
    showUnidadesMedidaSIEX: true,
    
    showUsuarios: false,
    hasClients: false,
    fincaName: 'Finca',
    fincasName: 'Fincas',
    showMapaRutas: true,

    // Aplicadores
    showAplicadoresFichajes: true,
    showAplicadoresPartes: true,
    showTrabajadoresCargos: true,

    // Maquinarias
    showTractorBoquillas: true,
    showTractorMarcha: true,
    showTractorPresion: true,
    showTractorRPM: true,
    showTractorVelocidad: true,
    showTractorKmRecorridos: true,

    // Tareas Genéricas
    showTareasOtros: true,
    showTareasOtrosDuracion: true,

    // Tareas Bio
    showTareasBio: true,
    showTareasBioParcelaMultiple: true,
    showTareasBioExportCsv: false,

    // Tareas Siembra
    showTareasSiembra: true,
    showTareasSiembraProductos: true,

    // Costes
    showCostes: true,
    showCostesOtros: true,

    // Stock
    showStock: true,
    showStockProveedor: true,
    showStockProveedorClienteDropdown: true,
    showStockEnvase: false,
    showStockSemilla: true,
    showStockReto: false,
    showStockTipoDeDato: true,

    // Visitas
    showVisitas: true,
    showVisitasConsultas: true,
    showEnviarWhatsappVisitas: true,
    showEnviarCorreoVisitas: true,
    showVisitasUploadPhotos: true,
    showVisitasCultivos: true,
    showVisitasVariedades: false,
    hiddenVisitasCerezo: true,
    showLocationLatLng: true,
    showVisitasCamposPersonalizados: true,

    // Otros
    showCalendarioTareas: true,
    timeStartStopTareas: true,
};
